<div data-cy="formly-dialog">
  <div class="tw-flex tw-justify-between tw-items-center tw-pr-4">
    <h2 class="mb-0" mat-dialog-title>
      {{ data?.title }}
    </h2>
    <mat-icon [mat-dialog-close]="deepCloneData.formlyConfig.model" aria-hidden="false">close</mat-icon>
  </div>

  <mat-dialog-content>
    <div *ngIf="(data.loadingInitData$ | async); else showFormData">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
    <ng-template #showFormData>
      <a id="topDialog"></a>
      <app-alert *ngIf="data.errorMessage" [message]="data.errorMessage" level="error">
      </app-alert>
      <div class="section-one-form">
        <p class="tw-mb-4" *ngIf="introText">{{ introText }}</p>
        <formly-form
          [form]="deepCloneData.formlyConfig.form"
          [fields]="deepCloneData.formlyConfig.fields"
          [model]="deepCloneData.formlyConfig.model"
          [options]="deepCloneData.formlyConfig.options">
        </formly-form>
      </div>
    </ng-template>
  </mat-dialog-content>
  <mat-dialog-actions class="!tw-p-0">
    <div class="tw-flex tw-w-full tw-justify-between tw-p-4 formly-dialog-actions-container">
      <div class="left-container">
        <button
          *ngIf="secondaryButtonText"
          mat-stroked-button
          autofocus="false"
          (click)="secondaryButton()">
          <mat-icon class="icon">{{ secondaryButtonIcon }}</mat-icon>
          <span>{{ secondaryButtonText }}</span>
        </button>
      </div>
      <div class="right-container">
        <button
          data-cy="formly-cancel-btn"
          mat-button
          (click)="cancelFormData()">
          {{ cancelButtonText }}
        </button>
        <button
          data-cy="formly-submit-btn"
          mat-raised-button
          color="primary"
          [disabled]="!deepCloneData.formlyConfig.form.valid || (!deepCloneData.ignoreDirty && !deepCloneData.formlyConfig.form.dirty) || (deepCloneData.loading$ | async) || deepCloneData.disableButton === true || (data.loading$ | async)"
          (click)="saveFormData()">
          <span *ngIf="!(data.loading$ | async)">{{ saveButtonText }}</span>
          <mat-spinner
            *ngIf="(data.loading$ | async)"
            diameter="24">
          </mat-spinner>
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</div>
